export const SET_SEARCH = 'SET_SEARCH';
export const SET_ORDER = 'SET_ORDER';
export const SET_FILTER_VALUE = 'SET_FILTER_VALUE';
export const SET_DISCOUNT_TAXES = 'SET_DISCOUNT_TAXES';
